import { type ContactMessageAck, type ContactMessageInput } from '@resolute/schema';
import { useMutation } from '@tanstack/react-query';


import { apiClient } from '@/lib/api-client';

/** Submit the general contact-page enquiry. */
export function useSubmitContact() {
  return useMutation({
    mutationFn: async (input: ContactMessageInput) => {
      const res = await apiClient.post<{ data: ContactMessageAck }>('/contact', input);
      return res.data.data;
    },
  });
}
